<template>
  <div class="pay-card-container">
    <a-tabs
      v-if="payMethodGroup.length"
      :defaultActiveKey="defaultActiveKey"
      @change="tabChangeHandler"
      type="card">
      <a-tab-pane
        v-for="(method, mId) in payMethodGroup"
        :tab="method.title"
        :key="mId + ''"
      >
        <template v-if="method.symbol === 'hnair_pay'">
          <hnair-pay :sellerCode="sellerCode" :sellerChannel="sellerChannel" ref="hnairPay"></hnair-pay>
        </template>
        <div class="pay-type-item"
          v-for="(bank, bankIndex) in method.items"
          :class="[{'active': bank.id === selectedBank.id }]"
          :key="bankIndex"
          :title="bank.label"
          :data-bankId="bank.bankId"
          :data-payType="bank.payType"
        >
          <i v-if="!bank.imgUrl" class="pay-type-icon" :class="[bank.id, bank.class]" @click="selectPayHandler(bank, method)">
            <template v-if="['alipYFK', 'YEEPAYCREDIT', 'ICBC-BIND', 'VR_PAY'].indexOf(bank.id) > -1">
              <span>{{ bank.label }}</span>
            </template>
          </i>
          <i v-else class="pay-type-image" @click="selectPayHandler(bank, method)">
            <img class="image" :src="bank.imgUrl" :alt="bank.label">
            <template v-if="['alipYFK', 'YEEPAYCREDIT', 'ICBC-BIND', 'VR_PAY'].indexOf(bank.id) > -1">
              <span>{{ bank.label }}</span>
            </template>
          </i>
          <template v-if="bank.id === 'HB'">
            <ant-credit-pay v-show="bank.id === selectedBank.id" :sellerCode="sellerCode" :sellerChannel="sellerChannel"  @selectPeriods='onSelectPeriods'></ant-credit-pay>
          </template>
        </div>
        <template v-if="method.description">
          <div class="pay-type-info">
            <span>说明：{{ method.description }}</span>
          </div>
        </template>
      </a-tab-pane>
    </a-tabs>
    <!--二维码支付弹窗-->
    <a-modal
      :title="payCodeTitle"
      v-model="payCodeVisible"
      wrapClassName="pay-modal"
      :footer="null"
      @cancel="payCodeCancelHandler"
    >
      <div class="pay-code">
        <img :src="payCode" :alt="payCodeTitle">
      </div>
    </a-modal>
    <!--虚拟账户预约弹窗-->
    <a-modal
      title="虚拟支付提示"
      v-model="vrPayModalVisible"
      wrapClassName="vr-pay-modal"
      :closable="false"
      :maskClosable="false"
      cancelText="取消支付"
      okText="确认支付"
      :okButtonProps="vrPayOkButtonProps"
      @ok="vrPayInfoOkHandle"
    >
      <div>虚拟账户信息：</div>
      <div class="vr-info-item">
        <div class="vr-label">虚拟币可使用余额</div>
        <div class="vr-context">￥{{ vrPayInfo.balanceAmount }}</div>
      </div>
      <div class="vr-info-item">
        <div class="vr-label">本日最大限额</div>
        <div class="vr-context">￥{{ vrPayInfo.limitDayAmount }}</div>
      </div>
      <div class="vr-info-item">
        <div class="vr-label">本日剩余额度</div>
        <div class="vr-context">￥{{ vrPayInfo.surplusAmount }}</div>
      </div>
      <div class="vr-pay-note" v-if="vrPayOkButtonProps.props.disabled">当日余额不足，请使用其他方式支付</div>
    </a-modal>
  </div>
</template>

<script>
import { payOrderNew, virtualPayInfo, showQRCode, payStateNew } from '@/apis/pay'
import { queryIsGroupStaff } from '@/apis/order'
import antCreditPay from './module/antCreditPay'
import hnairPay from './module/hnairPay'
import './css/pay-bank.less'
import payMethodGroup from './payMethod.js'
import _ from 'lodash'
import Observer from '@/assets/js/observer'
const { airline = '', cms = {} } = window.__MICRO_ROOT__

const mainSettings = window.__MICRO_ROOT__ ?? {}
// 支付场景映射
const symbolMap = {
  hasInsurance: 'has_insurance_pay',
  hasExtraAlone: 'extra_alone_pay',
  isChange: 'change_pay',
  isB2B: 'b2b_pay'
}

export default {
  name: 'l8-pay-box',
  components: {
    antCreditPay,
    hnairPay
  },
  props: {
    paySymbol: {
      type: Object,
      default: function () {
        return {
          hasInsurance: false, // 是否包含保险
          hasExtraAlone: false, // 是否单独辅营支付
          isChange: false, // 是否是改升支付
          isB2B: false // 是否代理人支付
        }
      }
    },
    // 销售渠道
    sellerCode: {
      type: String,
      default: airline
    },
    // 销售渠道Channel
    sellerChannel: {
      type: String,
      default: ''
    },
    // 承运航司
    owner: {
      type: String,
      default: airline
    },
    // 海航通支付限制条件
    // 不传就不会做海航通查询
    hnairPayFilter: {
      type: Function
    }
  },
  data () {
    return {
      defaultActiveKey: '0',
      // 支付分组
      payMethodGroup: [],
      payMethodGroupClone: payMethodGroup,
      // 选中的支付方式
      selectedBank: {},
      selectedMethod: {},
      // 支付接口传参
      payParams: {},
      // 二维码支付
      payCode: '',
      payCodeVisible: false,
      pollPayInt: '',
      pollPayIntCount: 6,
      // 支付跳转
      returnUrl: '',
      extraCommonParam: '',
      // 虚拟币支付
      vrPayModalVisible: false,
      vrPayInfo: {},
      vrPayOkButtonProps: { props: { disabled: false } },
      // 海航通场景
      isGroupStaff: false
    }
  },
  inject: {
    ifInternational: {
      value: 'ifInternational',
      default: null
    }
  },
  computed: {
    payCodeTitle () {
      const { selectedBank } = this
      return `${selectedBank.label}扫一扫支付`
    }
  },
  async created () {
    await this.getPayMethodGroup()
  },
  methods: {
    // 获取支付方式列表
    async getPayMethodGroup () {
      try {
        // payMethodSettings - 支付常用字段
        // extraPayMethodSettings - 支付拓展字段
        const { payMethodSettings, extraPayMethodSettings, payMethodAirlines } = await cms.getPageData()

        if (payMethodAirlines) {
          // 新的支付方式配置聚合
          await this.fetchAirlineMethods(payMethodAirlines)
        } else {
          // 旧逻辑：逐渐废除
          const { menus } = payMethodSettings ?? {}
          const { extraMenus } = extraPayMethodSettings ?? {}
          if (menus) {
            for (let index = 0; index < menus.length; index++) {
              menus[index].items = menus[index].children.filter(item => item.enable ?? true)
              // 补充拓展字段
              if (extraMenus?.length > 0) {
                menus[index].items?.forEach((item, itemIndex) => {
                  const extraItem = extraMenus.find(extraItem => extraItem.id === item.id && extraItem.enable)
                  if (extraItem) {
                    // this.$set(menus[index].items[itemIndex], 'imgUrl', extraItem.imgUrl)
                    this.$set(menus[index].items, itemIndex, {
                      ...menus[index].items[itemIndex],
                      imgUrl: extraItem.imgUrl,
                      returnUrl: extraItem.returnUrl
                    })
                  }
                })
              }
              delete menus[index].children
            }

            this.payMethodGroupClone = _.clone(menus || payMethodGroup)
          }
        }

        this.freshPayMethods()
      } catch (err) {
        console.log('err >>>> ', err)
        this.freshPayMethods()
      }
    },
    // 获取新的支付方式配置聚合
    async fetchAirlineMethods (payMethodAirlines) {
      try {
        const { owner } = this

        if (payMethodAirlines?.list?.length) {
          let moduleIds

          // 优先取销售渠道商的配置；如果没有取当前航司配置
          if (owner !== airline) {
            moduleIds = payMethodAirlines.list.find(item => item.airline === owner && item.enable)
          }

          if (!moduleIds) {
            moduleIds = payMethodAirlines.list.find(item => item.airline === airline && item.enable)
          }

          if (!moduleIds) {
            return Promise.reject(new Error(`请检查聚合配置，没有找到相应配置${owner}，没有找到默认配置${airline}`))
          }

          const moduleMap = [
            {
              key: 'groups',
              value: moduleIds.moduleId
            },
            {
              key: 'settings',
              value: moduleIds.settingModuleId
            }
          ]

          if (moduleIds.hnPayModuleId) {
            moduleMap.push({
              key: 'hnairPaySettings',
              value: moduleIds.hnPayModuleId
            })
          }

          const { groups, settings, hnairPaySettings } = (await cms.fetchData(moduleMap)) ?? {}

          // 配置聚合
          if (groups && settings) {
            _.remove(groups.menus, item => !item.enable)
            groups.menus.forEach(group => {
              const childrens = []
              group.list.map(item => {
                const setting = settings.list.find(setting => setting.id === item && setting.enable === true)

                if (setting) {
                  childrens.push(setting)
                }
              })
              group.items = childrens
            })
            _.remove(groups.menus, item => !item.items.length)
          } else {
            return Promise.reject(new Error('请检查聚合配置，获取不到分组或支付方式配置'))
          }

          if (hnairPaySettings) {
            await this.handleHnairPayExtend(hnairPaySettings)
          }

          if (groups.menus.length) {
            this.payMethodGroupClone = _.clone(groups.menus)
          }

          return Promise.resolve()
        }

        return Promise.reject(new Error('聚合配置数据为空'))
      } catch (err) {
        console.error('fetch airline methods error::', err)
        return Promise.reject(err)
      }
    },
    freshPayMethods () {
      const payMethodGroups = JSON.parse(JSON.stringify(this.payMethodGroupClone))
      let group = []
      const { paySymbol, isGroupStaff } = this
      const ifInternational = this.ifInternational?.() ?? false

      //  国际票场景
      if (ifInternational) {
        group = payMethodGroups.filter(item => item.symbol === 'international_pay')
      } else if (paySymbol) {
        // 其他场景过滤；互斥关系
        // 取第一个为 true 的
        let symbolKey

        for (const key of Object.keys(paySymbol)) {
          if (paySymbol[key] === true) {
            symbolKey = key
            break
          }
        }

        if (symbolKey) {
          group = payMethodGroups.filter(item => item.symbol === symbolMap[symbolKey])
        }
      }

      if (!group?.length) {
        group = payMethodGroups.filter(item => !item.symbol)
      }

      // 海航通场景；并集
      if (isGroupStaff) {
        const hnairPayGroups = payMethodGroups.filter(item => item?.symbol === 'hnair_pay')
        group = group.concat(hnairPayGroups)
      }

      let activeIndex = group.findIndex(item => item.active === true)

      if (activeIndex < 0) {
        activeIndex = 0
      }

      this.defaultActiveKey = activeIndex + ''
      if (group.length) {
        this.payMethodGroup = group
        this.selectPayHandler(group[activeIndex].items[0])
      }
    },
    // 海航通过滤
    async handleHnairPayExtend (config) {
      try {
        /**
         * cms 海航通条件限制与逻辑处理
         * enable - 总开关
         * internationalEnable - 支持国际票
         * mutualSaleEnable - 支持互售
         * multipleTripEnable - 支持多程
         * extraBookEnable - 支持随票辅营
         * jjcEnable - 支持军警残
         * useCouponEnable - 支持使用优惠券
         */
        const { hnairPayFilter } = this
        if (!hnairPayFilter) return
        const { menus = [] } = config
        // 这里取的其实是禁用逻辑
        const conditionKeys = menus.filter(item => !item.enable).map(item => item.key)
        const conditionMap = hnairPayFilter()
        const conditionFlag = conditionKeys.filter(key => conditionMap[key]?.())?.length === conditionKeys.length
        if (!conditionFlag) return

        this.isGroupStaff = await queryIsGroupStaff({})
      } catch (error) {
        console.log('海航通过滤error >>>> ', error)
      }
    },
    selectPayHandler (bank, method) {
      const { id } = this.selectedBank
      this.selectedBank = bank.id === id ? {} : bank
      this.selectedMethod = method
    },
    payCodeCancelHandler () {
      window.clearTimeout(this.pollPayInt)
      this.$emit('paid', this.selectedBank, 'CLOSE')
    },
    // 发起支付；前置校验
    async doPay (order) {
      const { orderId, orderNo, amount, orderType, returnUrl, extraCommonParam } = order
      const { selectedBank, selectedMethod, sellerCode, sellerChannel, owner } = this
      const { payType, bankId } = selectedBank
      const ifInternational = this.ifInternational?.() ?? false

      this.returnUrl = returnUrl
      this.extraCommonParam = extraCommonParam

      // 未选择支付方式校验
      if (!bankId && !payType) {
        this.$message.error('请选择支付方式！')
        return Promise.reject(new Error('请选择支付方式！'))
      }

      // 银联支付不传 returnUrl
      const unionPayFlag = ['GNETE_ALI', 'GNETE_WX'].includes(payType)
      const params = {
        'orderId': +orderId || orderId,
        orderNo,
        payType,
        'amount': +amount,
        bankId,
        orderType,
        extraCommonParam,
        ifInternational,
        seller: sellerCode,
        sellerChannel,
        owner
      }

      if (!unionPayFlag) {
        console.log('selectedBank >>>> ', selectedBank)
        params.returnUrl = selectedBank.returnUrl ? selectedBank.returnUrl : `${location.origin}${returnUrl}`
      }

      // 花呗增加入参
      if (payType === 'HB') {
        if (this.periods) {
          params.numOfPeriods = this.periods
        } else {
          this.$message.error('请先选择花呗分期期数')
          return Promise.reject(new Error('请先选择花呗分期期数'))
        }
      }

      // 海航通处理
      if (selectedMethod?.symbol === 'hnair_pay') {
        try {
          // 海航通校验
          await this.validateHnairPay()
        } catch (err) {
          return Promise.reject(new Error('海航通校验失败'))
        }

        // 海航通增加入参
        params.payExtInfo = {
          mergeType: 'CASE-YKT'
        }
      }

      this.payParams = params

      // TICKET("机票")
      // CHANGE("改升")
      // EXTRA("单独辅营")

      this.$emit('paying', this.selectedBank)

      if (params.payType === 'VR_PAY') {
        // 虚拟支付
        try {
          let vrPayBalance = await this.fetchVRPay()
          let checkResult = this.checkVrPayBalance(vrPayBalance, order)

          this.vrPayInfo = vrPayBalance

          if (checkResult) {
            this.vrPayOkButtonProps = { props: { disabled: false } }
            this.vrPayModalVisible = true
          } else {
            this.vrPayOkButtonProps = { props: { disabled: true } }
            this.vrPayModalVisible = true
          }
          return Promise.resolve(vrPayBalance)
        } catch (e) {
          this.$message.error(e.message || '获取虚拟支付信息失败')
          return Promise.reject(new Error(e.message || '获取虚拟支付信息失败'))
        }
      } else {
        // 常规支付
        return this.postPay()
      }
    },
    // 支付请求
    async postPay () {
      return new Promise((resolve, reject) => {
        const params = this.payParams
        const { selectedBank } = this
        const { methods, useInsideCode } = selectedBank

        payOrderNew(params).then((res) => {
          // 所有支付回调都依赖响应的url
          if (res.url) {
            if (methods) {
              switch (methods) {
                case 'scanCode':
                  this.showPayQRCode(res.paymentNo, res.url)
                  break
                case 'usePlatform':
                  this.$emit('paid', selectedBank, 'SUCCESS')
                  window.open(res.url, 'blank')
                  break
                case 'formSubmit':
                  this.$emit('paid', selectedBank, 'SUCCESS')
                  this.fetchFormSubmitPay(res)
                  break
                default:
                  this.$emit('paid', selectedBank, 'SUCCESS')
                  window.open(res.url, 'blank')
              }
            } else {
              // TODO: 临时兼容旧的交互方式
              if (
                _.isBoolean(useInsideCode)
                  ? useInsideCode
                  : (['WX'].includes(params.bankId) || params.payType.indexOf('GNETE_') >= 0 || params.payType.indexOf('CHINAPAY') >= 0)
              ) {
                this.showPayQRCode(res.paymentNo, res.url)
              } else {
                this.$emit('paid', selectedBank, 'SUCCESS')
                window.open(res.url, 'blank')
              }
            }
            resolve()
          }
        }).catch((err) => {
          this.$emit('paid', selectedBank, 'FAIL')
          this.$error({
            title: '温馨提示',
            content: err.message,
            okText: '知道了'
          })
          this.handleUniTrack(err)
          reject(new Error(err.message))
        })
      })
    },
    async validateHnairPay () {
      // NOTE: 调用支付执行相关校验
      const observer = new Observer()
      const user = mainSettings.user?.get() || {}
      // 实名认证标识
      const hasAuth = user.userType !== 0 || user.authStatus === 4
      // 海航通余额标识
      const oddFare = this.$refs['hnairPay']?.[0]?.yktResponse?.oddFare
      const hasOddFare = oddFare && oddFare !== '-'
      if (!hasAuth) {
        observer.add(() => {
          return new Promise((resolve, reject) => {
            this.$confirm({
              title: '温馨提示',
              content: `尊敬的旅客，使用海航通支付的账户须为实名认证账户，请您先完成实名认证。`,
              okText: '去实名认证',
              cancelText: '取消',
              onOk: () => {
                mainSettings.router?.push({
                  pathname: '/micro/user/authenticate',
                  query: { type: 'auth' }
                })
              },
              onCancel: () => {
                reject(new Error('cancel'))
              }
            })
          })
        })
      }
      if (!hasOddFare) {
        observer.add(() => {
          this.payLoading = false
          this.$error({
            title: '温馨提示',
            okText: '知道了',
            content: '账户余额不足，请您选择其他支付方式继续支付。'
          })
          return Promise.reject(new Error())
        })
      }

      if (observer.queue.length) {
        observer.start()
        return Promise.reject(new Error('海航通校验失败'))
      }
    },
    // 表单支付，就为了表单action
    fetchFormSubmitPay (res) {
      const form = document.createElement('form')

      // 设置表单的提交方式和支付页面的URL
      form.method = 'POST'
      form.action = res.url
      form.target = '_blank'

      for (const name in res.payData) {
        const orderInput = document.createElement('input')
        const value = res.payData[name]
        orderInput.type = 'hidden' // 一般支付信息应设为隐藏
        orderInput.name = name
        orderInput.value = value
        form.appendChild(orderInput)
      }
      document.body.appendChild(form)

      // 提交表单
      form.submit()

      // 销毁表单
      document.body.removeChild(form)
    },
    // 虚拟支付
    fetchVRPay () {
      const params = {
        loginId: mainSettings.user?.get()?.loginName,
        airlineCode: mainSettings.airline
      }
      return virtualPayInfo(params)
    },
    vrPayInfoOkHandle () {
      this.vrPayModalVisible = false
      this.postPay()
    },
    checkVrPayBalance (vrPayBalance, order) {
      return !(vrPayBalance.surplusAmount < order.amount)
    },
    // 系统内扫码支付
    showPayQRCode (paymentNo, url) {
      const { selectedBank } = this
      const params = {
        paymentNo,
        url
      }
      showQRCode(params).then((res) => {
        if (res) {
          this.payCodeVisible = true
          this.payCode = 'data:image/jpg;base64,' + res
          this.pollPayStatus(paymentNo)
        }
      }).catch((err) => {
        const label = selectedBank.label || '微信'
        this.payCodeVisible = false
        this.$emit('paid', selectedBank, 'FAIL')
        this.$message.error(err.message || `${label}二维码获取失败，请稍后再试`)
      })
    },
    // 轮询用户是否扫码支付
    pollPayStatus (paymentNo) {
      let self = this
      this.pollPayInt = setInterval(() => {
        self.fetchPayStatus(paymentNo)
      }, 5000)
    },
    fetchPayStatus (paymentNo) {
      const params = {
        paymentNo,
        seller: this.sellerCode,
        sellerChannel: this.sellerChannel
      }
      payStateNew(params).then((res) => {
        if (res === 'PAY_SUCCESS') {
          this.$emit('paid', this.selectedBank, 'SUCCESS')

          window.clearTimeout(this.pollPayInt)
          this.handleUniTrack()

          // vue-router 会对参数进行 encodeURIComponent, 不需要重复 encodeURIComponent
          const returnUrl = this.returnUrl.replace('/micro/main', '')
          this.$router.push({ path: returnUrl, query: { extra_common_param: this.extraCommonParam } })
        }
      }).catch((err) => {
        // 默认查询次数结束如还未成功，默认按失败返回
        if (this.pollPayIntCount > 0) {
          this.pollPayIntCount--
          return
        }

        this.payCodeVisible = false
        this.$emit('paid', this.selectedBank, 'FAIL')
        window.clearTimeout(this.pollPayInt)
        this.handleUniTrack(err)
      })
    },
    tabChangeHandler (activeKey) {
      let keyMap = _.map(this.payMethodGroup, (group) => (group.title))

      this.$emit('tabChange', {
        key: activeKey,
        label: keyMap[activeKey]
      })
    },
    // 花呗分期选择
    onSelectPeriods (periods) {
      this.periods = periods
    },
    handleUniTrack (error) {
      try {
        const { payParams } = this
        const trackParams = {
          common_pay_price: payParams.amount,
          common_pay_mode: payParams.payType
        }
        if (error) {
          trackParams.inf_error_info = error.message
          trackParams.common_pay_result = '支付失败'
        } else {
          trackParams.common_pay_result = '支付成功'
        }
        window.__MICRO_ROOT__?.api?.track?.('UNI_Pay', trackParams)
      } catch (error) {
        console.log('error >>>> ', error.message)
      }
    }
  }
}
</script>

<style lang="less">
  /*支付标签页*/
  .pay-card-container {
    background: #f5f5f5;
    overflow: hidden;
  }
  .pay-card-container > .ant-tabs-card > .ant-tabs-content {
    min-height: 120px;
    max-height: 300px;
    margin-top: -16px;
  }

  .pay-card-container > .ant-tabs-card > .ant-tabs-content > .ant-tabs-tabpane {
    background: #f5f5f5;
    padding: 20px 32px;
  }

  .pay-card-container > .ant-tabs-card > .ant-tabs-bar {
    border-color: #f5f5f5;
  }

  .pay-card-container > .ant-tabs-card > .ant-tabs-bar .ant-tabs-tab {
    border-color: #dddddd;
    background: #ffffff;
    border-radius: 0;
    margin-right: 0;
    padding: 0 40px;
    border-bottom: 1px solid #dddddd;
  }

  .pay-card-container > .ant-tabs-card > .ant-tabs-bar .ant-tabs-tab-active {
    border-color: #dddddd;
    background: #f5f5f5;
    color: #808080;
    border-radius: 0;
    padding: 0 40px;
    border-bottom: 1px solid transparent;
  }

  .pay-type-item {
    display: inline-block;
    margin: 5px 13px;
    width: 170px;
    min-height: 44px;
    text-align: center;
    cursor: pointer;
    .pay-type-icon, .pay-type-image {
      display: inline-block;
      border: 1px solid #ccc;
      height: 44px;
      line-height: 44px;
    }

    &.active {
      .pay-type-icon, .pay-type-image {
        border: 1px solid #e94250;
      }
    }
  }

  .pay-type-info {
    padding: 5px 0 10px 15px;
    font-weight: bolder;
  }

  .pay-code {
    text-align: center;
  }

  .vr-info-item {
    margin: 10px 0;

   .vr-label {
     display: inline-block;
     box-sizing: border-box;
     padding: 0 20px;
     width: 40%;
     text-align: right;
   }

    .vr-context {
      display: inline-block;
    }
  }

  .vr-pay-note {
    color: @primary-color;
    text-align: center;
  }

  @media only screen  and (max-width: 768px) {
    .pay-type-item {
      margin: 5px 0;
      width: 100%;
    }
  }
</style>
